import React from 'react';
import ReactTable from 'react-table';
import AutoScopeStylesDecorator from '../../../Common/Utilities/Decorators/AutoScopeStylesDecorator';
import applyDecoratorsDoNotUseInNewCode from '../../Utilities/Decorators/ApplyDecorators';

class DataTableView extends React.PureComponent {
    render() {
        const { className, ...remainingProps } = this.props;
        const newClassNameValue = '-striped -highlight DataTableViewSortIcon';
        return (
            // A div has been added so that the resulting html will be constructed with a data-component attribute with 'DataTableView' as the value in the div element.
            // Without the div the AutoScopeStylesDecorator did not add the data-component attribute anywhere in the resulting HTML. As far as it was concerned the
            // DataTableView component did not exist only the ReactTable component existed.
            <div>
                <ReactTable
                    className={newClassNameValue}
                    {...remainingProps}>
                </ReactTable>
            </div>
        );
    }
}

const withDecorators = applyDecoratorsDoNotUseInNewCode(AutoScopeStylesDecorator);

export default withDecorators(DataTableView);
